module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/headshot.jpg")
    }
  }), _vm._v(" "), _c('bio'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/kitty.jpg")
    }
  }), _vm._v(" "), _c('bio2')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3b92d8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bio.vue
// module id = 208
// module chunks = 0